import {LineCapStyle} from '@PosterWhiteboard/items/line-item/line-item.types';
import type {ReactElement} from 'react';
import {LineCapStyleOptionTypes} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-cap-style-option/line-cap-style-option.types';

const DEFAULT_COLOR = '#403F5D';
const SELECTED_COLOR = '#00688C';

const lineCapStyleNone = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M16.0001 27.488C22.3448 27.488 27.4882 22.3446 27.4882 15.9999C27.4882 9.65519 22.3448 4.51178 16.0001 4.51178C9.65537 4.51178 4.51196 9.65519 4.51196 15.9999C4.51196 22.3446 9.65537 27.488 16.0001 27.488Z"
      stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.87793 7.87781L24.1221 24.122" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const lineCapStyleArrowForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M7.66667 11L2.33333 16.3333M2.33333 16.3333L7.66667 21.6667M2.33333 16.3333H29"
      stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const lineCapStyleArrowForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M24.3333 11L29.6667 16.3333M29.6667 16.3333L24.3333 21.6667M29.6667 16.3333H3"
      stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const lineCapStyleCircleForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M9.15415 10.6918C12.0007 10.6918 14.3083 12.9994 14.3083 15.8459C14.3083 18.6925 12.0007 21.0001 9.15415 21.0001C6.30759 21.0001 4 18.6925 4 15.8459C4 12.9994 6.30759 10.6918 9.15415 10.6918Z"
      stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
      strokeWidth="2"
    />
    <path
      d="M29.6674 14.8459C30.2197 14.8459 30.6674 15.2936 30.6674 15.8459C30.6674 16.3981 30.2197 16.8459 29.6674 16.8459V15.8459V14.8459ZM13.2578 15.8459V14.8459L29.6674 14.8459V15.8459V16.8459L13.2578 16.8459V15.8459Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleCircleForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M22.8458 10.6918C19.9993 10.6918 17.6917 12.9994 17.6917 15.8459C17.6917 18.6925 19.9993 21.0001 22.8458 21.0001C25.6924 21.0001 28 18.6925 28 15.8459C28 12.9994 25.6924 10.6918 22.8458 10.6918Z"
      stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
      strokeWidth="2"
    />
    <path
      d="M2.33259 14.8459C1.78029 14.8459 1.33259 15.2936 1.33259 15.8459C1.33259 16.3981 1.78029 16.8459 2.33259 16.8459V15.8459V14.8459ZM18.7422 15.8459V14.8459L2.33259 14.8459V15.8459V16.8459L18.7422 16.8459V15.8459Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleSquareForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <mask id="mask0_3413_5598" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="1" y="9" width="13" height="13">
      <path
        d="M13.1084 22H1.86732C1.57277 22 1.33398 21.7612 1.33398 21.4667L1.33398 10.2256C1.33398 9.93108 1.57277 9.6923 1.86732 9.6923L13.1084 9.6923C13.4029 9.6923 13.6417 9.93108 13.6417 10.2256L13.6417 21.4667C13.6417 21.7612 13.4029 22 13.1084 22Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3413_5598)">
      <path
        d="M13.1084 22H1.86732C1.57277 22 1.33398 21.7612 1.33398 21.4667L1.33398 10.2256C1.33398 9.93108 1.57277 9.6923 1.86732 9.6923L13.1084 9.6923C13.4029 9.6923 13.6417 9.93108 13.6417 10.2256L13.6417 21.4667C13.6417 21.7612 13.4029 22 13.1084 22Z"
        stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
        strokeWidth="4"
      />
    </g>
    <path
      d="M28 14.8463C28.5523 14.8463 29 15.2941 29 15.8463C29 16.3986 28.5523 16.8463 28 16.8463V15.8463V14.8463ZM11.5898 15.8463V14.8463L28 14.8463V15.8463V16.8463L11.5898 16.8463V15.8463Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleSquareForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <mask id="mask0_3251_3262" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="16" y="9" width="13" height="13">
      <path
        d="M17.2256 22H28.4667C28.7612 22 29 21.7612 29 21.4667V10.2256C29 9.93108 28.7612 9.6923 28.4667 9.6923L17.2256 9.6923C16.9311 9.6923 16.6923 9.93108 16.6923 10.2256V21.4667C16.6923 21.7612 16.9311 22 17.2256 22Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3251_3262)">
      <path
        d="M17.2256 22H28.4667C28.7612 22 29 21.7612 29 21.4667V10.2256C29 9.93108 28.7612 9.6923 28.4667 9.6923L17.2256 9.6923C16.9311 9.6923 16.6923 9.93108 16.6923 10.2256V21.4667C16.6923 21.7612 16.9311 22 17.2256 22Z"
        stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
        strokeWidth="4"
      />
    </g>
    <path
      d="M2.33394 14.8463C1.78164 14.8463 1.33394 15.2941 1.33394 15.8463C1.33394 16.3986 1.78164 16.8463 2.33394 16.8463V15.8463V14.8463ZM18.7441 15.8463V14.8463L2.33394 14.8463V15.8463V16.8463L18.7441 16.8463V15.8463Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleDiamondForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <mask id="mask0_3413_5604" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="1" y="8" width="16" height="16">
      <path
        d="M8.53027 23.1973L1.71013 16.3771C1.50185 16.1688 1.50185 15.8312 1.71013 15.6229L8.53027 8.80274C8.73855 8.59446 9.07624 8.59446 9.28452 8.80274L16.1047 15.6229C16.3129 15.8312 16.3129 16.1688 16.1047 16.3771L9.28452 23.1973C9.07624 23.4055 8.73855 23.4055 8.53027 23.1973Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3413_5604)">
      <path
        d="M8.53027 23.1973L1.71013 16.3771C1.50185 16.1688 1.50185 15.8312 1.71013 15.6229L8.53027 8.80274C8.73855 8.59446 9.07624 8.59446 9.28452 8.80274L16.1047 15.6229C16.3129 15.8312 16.3129 16.1688 16.1047 16.3771L9.28452 23.1973C9.07624 23.4055 8.73855 23.4055 8.53027 23.1973Z"
        stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
        strokeWidth="4"
      />
    </g>
    <path
      d="M28.0002 15C28.5525 15 29.0002 15.4477 29.0002 16C29.0002 16.5523 28.5525 17 28.0002 17V16V15ZM13.7178 16V15L28.0002 15V16V17H13.7178V16Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleDiamondForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <mask id="mask0_3251_3295" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="14" y="8" width="15" height="16">
      <path
        d="M21.8027 23.1973L28.6229 16.3771C28.8312 16.1688 28.8312 15.8312 28.6229 15.6229L21.8027 8.80274C21.5945 8.59446 21.2568 8.59446 21.0485 8.80274L14.2284 15.6229C14.0201 15.8312 14.0201 16.1688 14.2284 16.3771L21.0485 23.1973C21.2568 23.4055 21.5945 23.4055 21.8027 23.1973Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3251_3295)">
      <path
        d="M21.8027 23.1973L28.6229 16.3771C28.8312 16.1688 28.8312 15.8312 28.6229 15.6229L21.8027 8.80274C21.5945 8.59446 21.2568 8.59446 21.0485 8.80274L14.2284 15.6229C14.0201 15.8312 14.0201 16.1688 14.2284 16.3771L21.0485 23.1973C21.2568 23.4055 21.5945 23.4055 21.8027 23.1973Z"
        stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
        strokeWidth="4"
      />
    </g>
    <path
      d="M2.33283 15C1.78053 15 1.33283 15.4477 1.33283 16C1.33283 16.5523 1.78053 17 2.33283 17V16V15ZM16.6152 16V15L2.33283 15V16V17H16.6152V16Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleTBarForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M3 21.3334L3 10.6667" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M27 15C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17V16V15ZM3 16L3 15L27 15V16V17L3 17V16Z" fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} />
  </svg>
);

const lineCapStyleTBarForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M28 21.3334V10.6667" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 15C3.4477 15 3 15.4477 3 16C3 16.5523 3.4477 17 4 17V16V15ZM28 16V15L4 15V16V17L28 17V16Z" fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} />
  </svg>
);

const lineCapStyleFilledArrowForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M1.07946 15.1364C0.773319 15.3485 0.773319 15.8011 1.07946 16.0132L9.60959 21.923C9.96329 22.1681 10.4467 21.9149 10.4467 21.4846L10.4467 9.66489C10.4467 9.23459 9.96329 8.98139 9.60959 9.22649L1.07946 15.1364Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
    <path
      d="M27.597 14.5748C28.1493 14.5748 28.597 15.0225 28.597 15.5748C28.597 16.1271 28.1493 16.5748 27.597 16.5748V15.5748V14.5748ZM10.4646 15.5748V14.5748L27.597 14.5748V15.5748V16.5748L10.4646 16.5748V15.5748Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleFilledArrowForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M28.3673 15.1364C28.6735 15.3485 28.6735 15.8011 28.3673 16.0132L19.8372 21.923C19.4835 22.1681 19.0001 21.9149 19.0001 21.4846V9.66489C19.0001 9.23459 19.4835 8.98139 19.8372 9.22649L28.3673 15.1364Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
    <path
      d="M1.85002 14.5748C1.29772 14.5748 0.850021 15.0225 0.850021 15.5748C0.850021 16.1271 1.29772 16.5748 1.85002 16.5748V15.5748V14.5748ZM18.9824 15.5748V14.5748L1.85002 14.5748V15.5748V16.5748L18.9824 16.5748V15.5748Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleFilledCircleForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="6.15415" cy="6.15415" r="6.15415" transform="matrix(1 0 0 -1 2.99976 22.1542)" fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} />
    <path
      d="M29.6661 15.0002C30.2184 15.0002 30.6661 15.4479 30.6661 16.0002C30.6661 16.5525 30.2184 17.0002 29.6661 17.0002V16.0002V15.0002ZM13.2559 16.0002V15.0002L29.6661 15.0002V16.0002V17.0002L13.2559 17.0002V16.0002Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleFilledCircleForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="22.8461" cy="16" r="6.15415" transform="rotate(-180 22.8461 16)" fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} />
    <path
      d="M2.33394 15.0002C1.78164 15.0002 1.33394 15.4479 1.33394 16.0002C1.33394 16.5525 1.78164 17.0002 2.33394 17.0002V16.0002V15.0002ZM18.7441 16.0002V15.0002L2.33394 15.0002V16.0002V17.0002L18.7441 17.0002V16.0002Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleFilledSquareForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M13.1084 22.1539H1.86732C1.57277 22.1539 1.33398 21.9151 1.33398 21.6205L1.33398 10.3795C1.33398 10.085 1.57277 9.84617 1.86732 9.84617L13.1084 9.84617C13.4029 9.84617 13.6417 10.085 13.6417 10.3795L13.6417 21.6205C13.6417 21.9151 13.4029 22.1539 13.1084 22.1539Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
    <path
      d="M28 15.0002C28.5523 15.0002 29 15.4479 29 16.0002C29 16.5525 28.5523 17.0002 28 17.0002V16.0002V15.0002ZM11.5898 16.0002V15.0002L28 15.0002V16.0002V17.0002L11.5898 17.0002V16.0002Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleFilledSquareForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M17.2256 22.1539H28.4667C28.7612 22.1539 29 21.9151 29 21.6205V10.3795C29 10.085 28.7612 9.84617 28.4667 9.84617L17.2256 9.84617C16.9311 9.84617 16.6923 10.085 16.6923 10.3795V21.6205C16.6923 21.9151 16.9311 22.1539 17.2256 22.1539Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
    <path
      d="M2.33394 15.0002C1.78164 15.0002 1.33394 15.4479 1.33394 16.0002C1.33394 16.5525 1.78164 17.0002 2.33394 17.0002V16.0002V15.0002ZM18.7441 16.0002V15.0002L2.33394 15.0002V16.0002V17.0002L18.7441 17.0002V16.0002Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleFilledDiamondForStart = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M8.53027 23.1973L1.71013 16.3771C1.50185 16.1688 1.50185 15.8312 1.71013 15.6229L8.53027 8.80274C8.73855 8.59446 9.07624 8.59446 9.28452 8.80274L16.1047 15.6229C16.3129 15.8312 16.3129 16.1688 16.1047 16.3771L9.28452 23.1973C9.07624 23.4055 8.73855 23.4055 8.53027 23.1973Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
    <path
      d="M28.0002 15C28.5525 15 29.0002 15.4477 29.0002 16C29.0002 16.5523 28.5525 17 28.0002 17V16V15ZM13.7178 16V15L28.0002 15V16V17H13.7178V16Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

const lineCapStyleFilledDiamondForEnd = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M21.8027 23.1973L28.6229 16.3771C28.8312 16.1688 28.8312 15.8312 28.6229 15.6229L21.8027 8.80274C21.5945 8.59446 21.2568 8.59446 21.0485 8.80274L14.2284 15.6229C14.0201 15.8312 14.0201 16.1688 14.2284 16.3771L21.0485 23.1973C21.2568 23.4055 21.5945 23.4055 21.8027 23.1973Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
    <path
      d="M2.33283 15C1.78053 15 1.33283 15.4477 1.33283 16C1.33283 16.5523 1.78053 17 2.33283 17V16V15ZM16.6152 16V15L2.33283 15V16V17H16.6152V16Z"
      fill={isSelected ? SELECTED_COLOR : DEFAULT_COLOR}
    />
  </svg>
);

export const getSvgFromPointStyle = (type: LineCapStyle, option: LineCapStyleOptionTypes, isSelected?: boolean): ReactElement | undefined => {
  switch (type) {
    case LineCapStyle.NONE:
      return lineCapStyleNone(isSelected);
    case LineCapStyle.ARROW:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleArrowForStart(isSelected) : lineCapStyleArrowForEnd(isSelected);
    case LineCapStyle.CIRCLE:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleCircleForStart(isSelected) : lineCapStyleCircleForEnd(isSelected);
    case LineCapStyle.SQUARE:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleSquareForStart(isSelected) : lineCapStyleSquareForEnd(isSelected);
    case LineCapStyle.DIAMOND:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleDiamondForStart(isSelected) : lineCapStyleDiamondForEnd(isSelected);
    case LineCapStyle.T_BAR:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleTBarForStart(isSelected) : lineCapStyleTBarForEnd(isSelected);
    case LineCapStyle.FILLED_ARROW:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleFilledArrowForStart(isSelected) : lineCapStyleFilledArrowForEnd(isSelected);
    case LineCapStyle.FILLED_CIRCLE:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleFilledCircleForStart(isSelected) : lineCapStyleFilledCircleForEnd(isSelected);
    case LineCapStyle.FILLED_SQUARE:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleFilledSquareForStart(isSelected) : lineCapStyleFilledSquareForEnd(isSelected);
    case LineCapStyle.FILLED_DIAMOND:
      return option === LineCapStyleOptionTypes.LINE_START ? lineCapStyleFilledDiamondForStart(isSelected) : lineCapStyleFilledDiamondForEnd(isSelected);
    default:
      return undefined;
  }
};
